import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Box, Card, CardContent, CardHeader, IconButton, List, ListItem, ListItemButton, ListSubheader, Tooltip, Typography } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import { useNavigate } from 'react-router-dom';
import _ from 'lodash'
import dayjs from 'dayjs';
import AddHardwareVersionButton from './add-hardwareversion-modal';
import { ObserveHardwareVersion, ObserveHardwareVersionsList } from './observers';
import { useDownloadFile } from '../../../hooks/use-download';

export const useNavigateToHardwareVersion = () => {
    const navigate = useNavigate();
    const handleClick = useCallback((id) => {
        navigate(`${id}/`);
    }, []);
    return handleClick;
}

const HardwareField = ({ label, value, width }) => (
    <Box sx={{ width, minWidth: width, flexShrink: 0 }}>
        <Typography variant="caption" color="text.secondary">{label}</Typography>
        <Typography variant="body2" noWrap>{value || '-'}</Typography>
    </Box>
);

HardwareField.propTypes = {
    label: PropTypes.string,
    value: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export function HardwareVersionListItem({ hardwareVersion, index }) {

    const downloadFile = useDownloadFile();

    const handleClick = useNavigateToHardwareVersion();

    const handleDownloadBundle = async (e) => {
        e.stopPropagation();
        const url = `${import.meta.env.VITE_BASE_ADMIN_API_URL}/hardwareversions/${hardwareVersion.id}/bundle`;
        await downloadFile(url, `bundle-${hardwareVersion.version}.zip`);
    };

    console.log('hardW', hardwareVersion.version, hardwareVersion.createdAt, hardwareVersion)

    return (
        <ListItem disablePadding onClick={() => handleClick(hardwareVersion.id)}>
            <ListItemButton>
                <Box sx={{ display: 'flex', gap: 2, width: '100%', alignItems: 'flex-start' }}>
                    <HardwareField label="#" value={String(index + 1)} width={50} />
                    <HardwareField label="Version" value={hardwareVersion.version} width={200} />
                    <HardwareField label="Type" value={hardwareVersion.type} width={150} />
                    <HardwareField label="Created" value={dayjs(hardwareVersion.createdAt).format('YYYY-MM-DD HH:mm')} width={130} />
                    <Box sx={{ flexGrow: 1 }} />
                    {hardwareVersion.bundle && (
                        <Tooltip title="Download Bundle">
                            <IconButton size="small" onClick={handleDownloadBundle}>
                                <DownloadIcon />
                            </IconButton>
                        </Tooltip>
                    )}
                </Box>
            </ListItemButton>
        </ListItem>
    )
}

HardwareVersionListItem.propTypes = {
    hardwareVersion: PropTypes.any,
    index: PropTypes.number
}

export const ObservedHardwareListItem = ObserveHardwareVersion(HardwareVersionListItem);

export function HardwareVersionsListInternal({ hardwareVersions }) {
    const groupedByType = _.groupBy(hardwareVersions, 'type');

    return (
        <List dense>
            {_.map(groupedByType, (items, type) => (
                <React.Fragment key={type}>
                    <ListSubheader>{type}</ListSubheader>
                    {_.map(items, (hardwareVersion, index) =>
                        <ObservedHardwareListItem
                            key={hardwareVersion.id}
                            hardwareVersion={hardwareVersion}
                            index={index}
                        />
                    )}
                </React.Fragment>
            ))}
        </List>
    );
}

HardwareVersionsListInternal.propTypes = {
    hardwareVersions: PropTypes.array
}

export const ObservedHardwareVersionsList = ObserveHardwareVersionsList(HardwareVersionsListInternal);

export default function HardwareVersionsList() {
    return (
        <Card>
            <CardHeader
                action={<AddHardwareVersionButton />}
                title="Hardware Versions"
            />
            <CardContent>
                <ObservedHardwareVersionsList />
            </CardContent>
        </Card>
    );
};
